




























import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import ConfirmModal from "@/components/modal/Confirm.vue";
import WebhookForm from "./Form.vue";
import { WebhookDto } from "@/store/webhooks/webhook.interface";
import Webhook from "@/store/webhooks";
import { ServerConfig } from "@/config";

@Component({
  components: {
    "webhook-form": WebhookForm
  }
})
export default class AppWebhookView extends Vue {
  isLoading: boolean = false;
  error: any = "";
  data: any = null;
  temp: any = null;
  id: number = 0;
  disabled: boolean = true;

  mounted() {
    this.sockets.subscribe("webhookUpdated_" + this.id, (data: any) => {
      this.data = JSON.parse(JSON.stringify(data));
      this.temp = JSON.parse(JSON.stringify(data));
    });
  }

  destroyed() {
    this.sockets.unsubscribe("webhookUpdated_" + this.id);
  }

  async created() {
    this.id = parseInt(this.$route.params.id);
    const res = await Webhook.findOne(this.id);
    this.data = JSON.parse(JSON.stringify(res.response.data));
    this.temp = JSON.parse(JSON.stringify(res.response.data));
  }

  onEditable() {
    this.disabled = false;
  }

  async onSubmit(form: any) {
    this.error = "";
    this.isLoading = true;
    try {
      await Webhook.updateOne(this.id, form);
      const res = await Webhook.findOne(this.id);
      this.data = JSON.parse(JSON.stringify(res.response.data));

      this.disabled = true;
      this.isLoading = false;
      this.$toasted.success("Saved");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.webhook;
      this.$toasted.error(this.error);
    }
  }

  async onConfirmRemove() {
    this.isLoading = true;
    try {
      await Webhook.removeOne(this.id);
      this.$router.back();
      this.isLoading = false;
      this.$toasted.success("Removed");
    } catch (error) {
      this.isLoading = false;
      this.error = error.response.data.webhook;
      this.$toasted.error(this.error);
    }
  }

  async onRemove() {
    return (this.$refs.confirmModal as ConfirmModal).open();
  }

  async onCancel() {
    this.data = JSON.parse(JSON.stringify(this.temp));
    this.disabled = true;
  }

  get webhookUrl() {
    if (this.data) {
      return ServerConfig.API_URL + "/webhooks/receiver/" + this.data.code;
    }
    return "";
  }
}
